import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import Select from 'react-select';

import './styles.css';

class NameInput extends Component {
  constructor(props){
    super(props);
    this.state = {
      selected: 'Mr',
      options: [
        {label: 'Mr', value: 'Mr'},
        {label: 'Ms', value: 'Ms'},
        {label: 'Mrs', value: 'Mrs'}
      ],
      text: '',
      value: 'Mr ',
    }
  }

  componentDidMount() {
    this.update = debounce(this.update, 200);
  }
  componentWillMount(){
    if(this.props.value){
      let parts = this.props.value.split(' ');
      let prename = parts.splice(0,1)[0];
      let name = parts.join(' ');
      this.setState({selected: prename, text: name, value: `${prename} ${name}`});
    }
  }
  handleSelectChange(e){
    this.setState({selected: e.value, value: `${e.value} ${this.state.text}`}, () => {
      this.update();
    });
  }
  handleInputChange(e){
    this.setState({text: e.target.value, value: `${this.state.selected} ${e.target.value}`}, () => {
      this.update();
    })
  }
  update(){
    if(this.props.onChange){
      this.props.onChange.call(null, this.state.value);
    }
  }
  render(){
    return (
      <div className="form-controls-row">
        <div className="form-control-cell" style={{width:"90px"}}>
          <Select
            searchable={false}
            clearable={false}
            arrowRenderer={null}
            name="form-field-name"
            value={this.state.selected}
            onChange={this.handleSelectChange.bind(this)}
            options={this.state.options}
          />
        </div>
        <div className="form-control-cell">
          <label>Name</label>
          <input value={this.state.text} onChange={this.handleInputChange.bind(this)} type="text" name='name' />
        </div>
      </div>
    );
  }
}

export default NameInput;



// WEBPACK FOOTER //
// ./src/components/NameInput/NameInput.js